// Classes Page - List all gymnastics classes
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';

const fetchClasses = async () => {
  const res = await fetch('/api/public/classes');
  return res.json();
};

export default function Classes() {
  const { data, isLoading } = useQuery('classes', fetchClasses);
  const classes = data?.data || [];
  
  const categories = [...new Set(classes.map((c: any) => c.category))];
  
  return (
    <div>
      <section className="relative py-32 bg-gradient-to-br from-secondary to-primary text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="font-heading text-5xl font-bold mb-6">Our Classes</h1>
          <p className="text-xl max-w-2xl mx-auto opacity-90">
            Gymnastics for all ages and abilities - from pre-school to competitive training
          </p>
        </div>
      </section>
      
      <section className="py-20">
        <div className="container mx-auto px-4">
          {isLoading ? (
            <div className="text-center py-12"><span className="loading loading-spinner loading-lg text-primary"></span></div>
          ) : (
            categories.map(category => (
              <div key={category} className="mb-12">
                <h2 className="font-heading text-2xl font-bold mb-6 capitalize">{category?.replace('-', ' ')}</h2>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {classes.filter((c: any) => c.category === category).map((cls: any) => (
                    <div key={cls.id} className="card bg-base-100 shadow-lg card-hover">
                      <div className="h-40 bg-gradient-to-br from-primary/20 to-secondary/20 flex items-center justify-center text-6xl">
                        {cls.category === 'pre-school' ? '🧒' : cls.category === 'artistic' ? '🤸' : cls.category === 'rhythmic' ? '🎀' : cls.category === 'holiday-camp' ? '⛱️' : cls.category === 'birthday-party' ? '🎉' : '🌟'}
                      </div>
                      <div className="card-body">
                        <h3 className="card-title">{cls.name}</h3>
                        <p className="text-sm text-gray-500">Ages {cls.minAge}{cls.maxAge ? `-${cls.maxAge}` : '+'}</p>
                        <p className="text-gray-600 mt-2">{cls.description}</p>
                        <div className="flex items-center justify-between mt-4">
                          <span className="text-2xl font-bold text-primary">£{cls.price}</span>
                          <Link to={`/classes/${cls.slug}`} className="btn btn-primary btn-sm text-white">Details</Link>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))
          )}
        </div>
      </section>
    </div>
  );
}